import {
  CoverageStrategy,
  OptimizationMode,
  OptimizationStatus,
} from '@features/accounts/enums';
import { CommonApplicationEligibility } from '@features/user/types/common-application-eligibility';

export type GetProfileResponse = {
  uuid: string;
  firstName: string;
  middleName?: string | null;
  lastName: string;
  email: string;
  acceptedTerms: boolean;
  activeApiChecking: boolean;
  activeMaxChecking: boolean;
  ageRange: string;
  businessUser: boolean;
  commonApplicationEligibility: CommonApplicationEligibility;
  completedProfile: boolean;
  coverageStrategy: CoverageStrategy;
  enterpriseIdentifier: string | null;
  exemptFromMinimumFee: boolean;
  externalAccounts: boolean;
  fundsTransferable: boolean;
  invitationSettings: InvitationSettings;
  inviteCode?: string | null;
  memberLevel: string;
  onboardingStatus: string;
  optimizationSettings: OptimizationSettings;
  partner?: Partner;
  seasoned: boolean;
  sharedWithAdvisor: boolean;
  showExternalAccounts: boolean;
  singleHub: boolean;
  state: UserState;
  createdAt: string;
  updatedAt: string;
  timeoutIn: number;
};

export type Partner = {
  uuid: string;
  name: string;
  domain: string;
  singleHubName?: string;
};

export type InvitationSettings = {
  show: boolean;
  remaining: number;
};

export type OptimizationSettings = {
  hasOptimized: boolean;
  optimizationStatus: OptimizationStatus;
  runningOptimizations: boolean;
  nextScheduledOptimization?: Optimization;
  optimizationSchedule: OptimizationSchedule;
};

export type Optimization = {
  uuid: string;
  scheduledAt: string;
  state: string;
  recurring: boolean;
  resumation: boolean;
  createdAt: string;
  updatedAt: string;
};

export type OptimizationSchedule = {
  lastOptimizationAt?: string;
  mode: OptimizationMode;
  optimizationDayOfMonth?: number;
  resumeAt?: string | null;
  createdAt?: string;
  updatedAt?: string;
};

export enum UserState {
  // Mirrors the Rails user state machine (app/models/user/status.rb):
  // pending, in_review, approved, rejected, held.
  Pending = 'pending',
  InReview = 'in_review',
  Approved = 'approved',
  Rejected = 'rejected',
  Held = 'held',
}
